export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(dateStr + "T00:00:00");
  return Math.round((d - today) / 86400000);
}

export function isoToEu(iso) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return "";
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
}

export function euToIso(v) {
  if (typeof v !== "string") return null;
  const m = v.trim().match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!m) return null;
  const [, d, mo, y] = m;
  const dt = new Date(`${y}-${mo}-${d}T00:00:00`);
  if (isNaN(dt) || dt.getDate() !== +d || dt.getMonth() + 1 !== +mo || dt.getFullYear() !== +y) return null;
  return `${y}-${mo}-${d}`;
}

export function addDaysIso(iso, days) {
  const dt = new Date(iso + "T00:00:00");
  dt.setDate(dt.getDate() + days);
  const p = (n) => String(n).padStart(2, "0");
  return `${dt.getFullYear()}-${p(dt.getMonth() + 1)}-${p(dt.getDate())}`;
}

export function formatDate(dateStr) {
  return isoToEu(dateStr) || "—";
}

// Returns urgency key: overdue | due_3 | due_7 | due_14 | later | done
export function urgencyOf(dateStr, status) {
  if (status === "Completed") return "done";
  const days = daysUntil(dateStr);
  if (days === null) return "later";
  if (days < 0) return "overdue";
  if (days <= 3) return "due_3";
  if (days <= 7) return "due_7";
  if (days <= 14) return "due_14";
  return "later";
}

export const URGENCY = {
  overdue: {
    label: "Overdue",
    badge: "bg-red-50 text-red-800 border-red-200",
    bar: "border-l-red-600",
    dot: "bg-red-600",
  },
  due_3: {
    label: "Due within 3 days",
    badge: "bg-amber-50 text-amber-800 border-amber-200",
    bar: "border-l-amber-600",
    dot: "bg-amber-600",
  },
  due_7: {
    label: "Due within 7 days",
    badge: "bg-yellow-50 text-yellow-800 border-yellow-200",
    bar: "border-l-yellow-600",
    dot: "bg-yellow-600",
  },
  due_14: {
    label: "Due within 14 days",
    badge: "bg-sky-50 text-sky-800 border-sky-200",
    bar: "border-l-sky-600",
    dot: "bg-sky-600",
  },
  later: {
    label: "Later",
    badge: "bg-slate-50 text-slate-600 border-slate-200",
    bar: "border-l-slate-300",
    dot: "bg-slate-400",
  },
  done: {
    label: "Completed",
    badge: "bg-green-50 text-green-700 border-green-200",
    bar: "border-l-green-600",
    dot: "bg-green-600",
  },
};

export function daysLabel(dateStr) {
  const days = daysUntil(dateStr);
  if (days === null) return "";
  if (days < 0) return `${Math.abs(days)} day${Math.abs(days) === 1 ? "" : "s"} overdue`;
  if (days === 0) return "Due today";
  if (days === 1) return "Due tomorrow";
  return `Due in ${days} days`;
}

export function reminderReached(reminderDates, createdAt) {
  if (!reminderDates || reminderDates.length === 0) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const created = createdAt ? String(createdAt).slice(0, 10) : null;
  return reminderDates.some((r) => {
    const d = new Date(r + "T00:00:00");
    // Reminders that were already past when the record was created are not current reminders.
    return d <= today && (!created || r >= created);
  });
}
